import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigFirecrawlMcpSettings } from "./app-settings-config-firecrawl";

export interface IConfigFirecrawlMcpInputState {
  showModal: boolean;
  editingFirecrawlMcpId: string;
}

export interface IConfigFirecrawlMcpInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigFirecrawlMcpInput extends PureComponent<
  IConfigFirecrawlMcpInputProps,
  IConfigFirecrawlMcpInputState
> {
  formInputName: string[] = ["apiConfig", "firecrawlMcpSettingsId"];

  constructor(props: IConfigFirecrawlMcpInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingFirecrawlMcpId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingFirecrawlMcpId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingFirecrawlMcpId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigFirecrawlMcpSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingFirecrawlMcpId={this.state.editingFirecrawlMcpId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Firecrawl"
          formInputName={this.formInputName}
          options={this.props.commonSettings.firecrawlMcpSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_firecrawlmcp"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpFirecrawlDropdown"
          addNewTestId="appSettingsMcpFirecrawlAddNewButton"
          editTestId="appSettingsMcpFirecrawlEditButton"
        />
      </>
    );
  }
}
